import red from "@material-ui/core/colors/red";
import IconButton from "@material-ui/core/IconButton";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import RemoveIcon from "@material-ui/icons/Remove";
import classNames from "classnames";
import React from "react";
import { ArrayFieldTemplateItemProps as RjsfArrayFieldTemplateItemProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    itemRoot: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    item: {
      flex: 1,
    },
    itemActions: {
      width: "auto",
      textAlign: "right",
    },
    removeButton: {
      color: red[500],
      "&:hover": {
        backgroundColor: red[50],
      },
    },
  });

export interface ArrayFieldTemplateItemProps extends RjsfArrayFieldTemplateItemProps, WithStyles<typeof styles> {}

export const ArrayFieldTemplateItemComponent = (props: ArrayFieldTemplateItemProps) => {
  const {
    children,
    index,
    disabled,
    readonly,
    hasMoveUp,
    hasMoveDown,
    hasRemove,
    hasToolbar,
    className,
    classes,
    onDropIndexClick,
    onReorderClick,
  } = props;

  const isOrderable = hasMoveUp || hasMoveDown;

  return (
    <div className={classNames(classes.itemRoot, className)}>
      <div className={classes.item}>{children}</div>
      {hasToolbar && (
        <div className={classes.itemActions}>
          {isOrderable && (
            <Tooltip
              title="Move Up"
              disableFocusListener={disabled || readonly}
              disableHoverListener={disabled || readonly}
              disableTouchListener={disabled || readonly}
            >
              <span>
                <IconButton
                  disabled={disabled || readonly || !hasMoveUp}
                  aria-label="move up"
                  onClick={onReorderClick(index, index - 1)}
                >
                  <ArrowUpwardIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {isOrderable && (
            <Tooltip
              title="Move Down"
              disableFocusListener={disabled || readonly}
              disableHoverListener={disabled || readonly}
              disableTouchListener={disabled || readonly}
            >
              <span>
                <IconButton
                  disabled={disabled || readonly || !hasMoveDown}
                  aria-label="move down"
                  onClick={onReorderClick(index, index + 1)}
                >
                  <ArrowDownwardIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {hasRemove && (
            <Tooltip
              title="Remove"
              disableFocusListener={disabled || readonly}
              disableHoverListener={disabled || readonly}
              disableTouchListener={disabled || readonly}
            >
              <span>
                <IconButton
                  className={classes.removeButton}
                  disabled={disabled || readonly}
                  aria-label="delete"
                  onClick={onDropIndexClick(index)}
                >
                  <RemoveIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
};

export const ArrayFieldTemplateItem = withStyles(styles)(ArrayFieldTemplateItemComponent);
